var map = {
	"./content-deco-1.webp": 1467,
	"./content-deco-2.webp": 1468,
	"./deposit-icon.webp": 1469,
	"./home-icon-active.webp": 1470,
	"./home-icon.webp": 1471,
	"./live-icon-active.webp": 1472,
	"./live-icon.webp": 1473,
	"./me-icon-active.webp": 1474,
	"./me-icon.webp": 1475,
	"./product-overview-bg.webp": 1476,
	"./promos-icon-active.webp": 1477,
	"./promos-icon.webp": 1478,
	"./services-bg.webp": 1479,
	"./sponsor-icon-active.webp": 1480,
	"./sponsor-icon.webp": 1481,
	"./vip-icon.webp": 1482,
	"./withdraw-icon.webp": 1483,
	"./wwr-img.webp": 1484
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 172;